import header from './Header.module.css';
import React, { useEffect, useRef, useState } from 'react';
import { getAuthTokenOrLogOut } from '../../util';
import { signOut } from 'aws-amplify/auth';

export const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const wrapperRef: any = useRef('menu');

  // handles the click anywhere on the screen to close the burger menu
  function useClickOutside(ref: any, onClickOutside: any) {
    useEffect(() => {
      function handleClickOutside(event: { target: any }) {
        if (ref.current && !ref.current.contains(event.target)) {
          onClickOutside();
        }
      }
      // Bind
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // dispose
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref, onClickOutside]);
  }

  useClickOutside(wrapperRef, () => {
    setIsOpen(false);
  });

  async function checkLoggedIn() {
    const userDetails = await getAuthTokenOrLogOut();
    if (userDetails.token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }

  async function handleSignOut() {
    try {
      setIsOpen(false);
      await signOut();
      window.location.reload();
    } catch (error) {
      console.error('Error signing out: ', error);
      // Even if sign-out fails, a reload might resolve an inconsistent state
      window.location.reload();
    }
  }

  return (
    <div className={header.headerContainer}>
      <div className={header.headerBrandContainer}>
        <img src="/images/ovo_brand_logo.svg" alt="ovo-logo" width="48" height="48" />
        <h2 className={header.headerTitle}>Miles</h2>
      </div>
      <span className={header.headerIconMenu} ref={wrapperRef}>
        <button
          className={header.headerIconMenuButton}
          onClick={() => {
            checkLoggedIn();
            setIsOpen(!isOpen);
          }}
        >
          <img src="/images/hamburger_menu.svg" alt="hamburger-menu" width="24" height="24" />
        </button>
        {isLoggedIn && isOpen && (
          <div>
            <ul className={header.hamburgerList}>
              <li className={header.hamburgerListItem}>
                <button onClick={handleSignOut} className={header.hamburgerListButton}>
                  Logout
                </button>
              </li>
            </ul>
          </div>
        )}
      </span>
    </div>
  );
};

export default Header;
